import app from 'flarum/common/app';
import { apiUrl } from './flame';
/**
 * One request per distinct query, shared by every component that asks.
 *
 * 🚨 Module-level, not component fields: Bespoke and other hosts rebuild their
 * widgets on a redraw, and a component that keeps its own data starts empty
 * each time — spinning and re-requesting for as long as the page is open.
 */
const cache = new Map();
function load(key, url, params) {
  const entry = cache.get(key) || {};
  cache.set(key, entry);
  if (!entry.data && !entry.failed && !entry.pending) {
    entry.pending = app.request({
      method: 'GET',
      url,
      params
    }).then(res => {
      entry.data = res.data;
    }).catch(() => {
      entry.failed = true;
    }).finally(() => {
      entry.pending = undefined;
      m.redraw();
    });
  }
  return entry;
}
export function member(userId, query) {
  return load(`member:${userId}:${query.year || ''}:${query.month || ''}`, apiUrl(`/cadence/streaks/${userId}`), query);
}
export function board(name, limit, offset, extras) {
  if (limit === void 0) {
    limit = 50;
  }
  if (offset === void 0) {
    offset = 0;
  }
  if (extras === void 0) {
    extras = {};
  }
  const params = {
    board: name,
    limit,
    offset,
    ...extras
  };
  return load(`board:${JSON.stringify(params)}`, apiUrl('/cadence/streaks'), params);
}

/** Forget everything about a member (after a feed or a staff change). */
export function forget(userId) {
  for (const key of [...cache.keys()]) {
    if (!userId || key.startsWith(`member:${userId}:`) || key.startsWith('board:')) cache.delete(key);
  }
}
flarum.reg.add('ernestdefoe-cadence', 'common/streak/store', { member: member,board: board,forget: forget, });